import { defineNuxtPlugin } from '#app'
import { registerBugsnagVueApp } from '@render/integrations/bugsnag/bugsnag'

export default defineNuxtPlugin((nuxtApp) => {
  registerBugsnagVueApp(nuxtApp.vueApp)
})
